import { render, staticRenderFns } from "./NavigationButton.vue?vue&type=template&id=e71471b6&"
import script from "./NavigationButton.vue?vue&type=script&lang=ts&"
export * from "./NavigationButton.vue?vue&type=script&lang=ts&"
import style0 from "./NavigationButton.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports